/**
 * The ONLY static user-facing copy on the desk (PPL-416 / PPL-417).
 *
 * Everything else — names, counts, days, reasons, the opener, the prompts,
 * the pill label — arrives in the payload. The templates at the bottom take
 * a NAME the payload carries and never compose one; they are the composer
 * prefills the route map (useHomeActions.ts) hands the page for a module's
 * primary tap. Listed in the PR.
 */
export const HOME_STATIC = {
  /** §9 error / offline with no payload, and a cold opener that failed. */
  bareLine: 'What’s on your mind?',
  /** Zone A before a payload has named the stage — the existing pill's label. */
  pillDefault: 'f8 · ready',
  /** S0's two paths (O4 resolved). */
  bringPpl: 'Bring your ppl',
  bringPplSub: 'sync your contacts',
  bringPplPill: 'get the app',
  meetPpl: 'Meet new ppl',
  meetPplDiscover: 'discover',
  meetPplPosts: 'posts',
  /** §9 offline, shown above the composer. */
  offlineHint: 'offline — f8 will catch up when you’re back',
  asOf: 'as of',
  /** W-H1 signed out (canvas w2). */
  signedOutPill: 'f8 · hi',
  signedOutIntro: 'I’m f8. Tell me about one person you want to keep close.',
  signedOutEmphasis: 'one person',
  signedOutStarters: ['my best friend from uni — we drifted', 'my mum. I forget to call', 'someone I just met and want to keep'],
  signedOutHint: 'sending your first message signs you in',

  // ── prefill templates (PPL-417 route map) — `name` is always the payload's ──
  /** M4 when the feed has no opener reply. */
  todayPrefill: (name: string) => `what should I know before seeing ${name}?`,
  /** M4 after the event ("how was it?"). */
  postEventPrefill: (name: string) => `here’s how it went with ${name}`,
  /** M5 primary. */
  datesPrefill: (kind: 'birthday' | 'anniversary', name: string) => `help me write ${kind === 'anniversary' ? 'an anniversary' : 'a birthday'} note to ${name}`,
  /** M6 primary — the existing "ask f8 about X" path. */
  checkinPrefill: (name: string) => `help me check in on ${name}`,
} as const;
